import React from 'react';
import styled from 'styled-components';

import LinesEllipsis from 'react-lines-ellipsis';
import withI18n from '../../../utils/withI18n';
import { getLabel } from '../../../utils/i18n';
import FlexBox from '../../FlexBox';

import { gwGet } from '../../../actions/actionsFactory/gwRequest';
import API_PATH from '../../../actions/actionsFactory/apiPath';
import { formatDate } from '../../../utils/datetime';
import urls from '../../../config/urls';

const WrapperBox = styled(FlexBox)`
  width: 100%;
  height: auto;
  overflow: hidden;
  padding: 90px 0 100px 0;
  border-bottom: 1px solid rgba(234, 236, 239, 1);
  font-family: ${({ theme }) => theme.fontIBMLight};
  background: #fff;
`;
const Content = styled.div`
  width: 100%;
  max-width: 1260px;
  margin: 0 auto;
`;
const Title = styled.div`
  font-size: 54px;
  font-weight: 200;
  color: #212833;
  padding-bottom: 25px;
`;
const Description = styled.div`
  font-size: 16px;
  color: #48515d;
  font-family: ${({ theme }) => theme.fontIBMMedium};
`;

const List = styled(FlexBox)`
  width: 100%;
  margin-top: 100px;
`;
const ListLeft = styled.div`
  width: 744px;
  height: 388px;
  overflow: hidden;
  img {
    width: 100%;
  }
`;
const ListRight = styled.div`
  width: 440px;
  > span {
    display: inline-block;
    margin-right: 10px;
    height: 26px;
    line-height: 26px;
    background: rgba(240, 185, 11, 0.2);
    border-radius: 3px;
    padding: 0 10px;
    font-size: 14px;
    color: #f0b90b;
    font-family: ${({ theme }) => theme.fontIBMMedium};
  }
  > h2 {
    font-size: 20px;
    color: #0b0e11;
    margin: 10px 0;
    > a {
      color: #0b0e11;
      font-family: ${({ theme }) => theme.fontIBMMedium};
    }
  }
  > p {
    margin-bottom: 10px;
    color: #848e9c;
    font-size: 14px;
    font-family: ${({ theme }) => theme.fontIBMRegular};
  }
  > div {
    color: #848e9c;
    font-size: 14px;
    line-height: 22px;
    font-family: ${({ theme }) => theme.fontIBMRegular};
  }
  > a {
    color: #212833;
    font-size: 16px;
    font-family: ${({ theme }) => theme.fontIBMMedium};
  }
`;

const FourData = styled.div`
  margin: 30px 0 20px 0;
  > ul {
    margin: 0;
    padding: 0;
    list-style: none;
    padding-top: 30px;
    border-top: 1px solid rgba(234, 236, 239, 1);
    > li {
      margin: 0 0 10px 0;
      padding: 0;
      height: 22px;
      line-height: 22px;
      > a {
        color: #48515d;
        font-size: 14px;
        font-family: ${({ theme }) => theme.fontIBMRegular};
        > div.LinesEllipsis {
          float: left;
          width: 350px;
        }
      }
      > span {
        margin-left: 15px;
        float: right;
        font-family: ${({ theme }) => theme.fontIBMRegular};

      }
    }
  }
`;

type Props = {
  i18n: Object,
  locale: string,
};

type State = {
  fourData: Array<Object>,
  firstData: Object,
};

export default
@withI18n
class Announcements extends React.Component<Props, State> {
  static defaultProps = {
    i18n: {},
    locale: 'en',
  };

  state = {
    firstData: {},
    fourData: [],
  };

  componentDidMount() {
    this._getAnnouncementsList();
  }

  componentWillReceiveProps(nextProps: Object) {
    if (this.props.locale !== nextProps.locale) {
      this._getAnnouncementsList();
    }
  }

  _getAnnouncementsList = async () => {
    try {
      const result = await gwGet(`${API_PATH.GET_NOTICE_API_PATH}?page=1&rows=5`);
      const { data, success } = result;
      if (success && data) {
        data[0].image = require('./testImg/announcements.png');
        const arr = [];
        for (let i = 1; i < 5; i++) {
          arr.push(data[i]);
        }
        this.setState({ firstData: data[0], fourData: arr });
      }
    } catch (error) {
      throw error;
    }
  };

  render() {
    const { i18n, locale } = this.props;
    const { firstData, fourData } = this.state;
    const viewAll = urls.external.announcements;
    return (
      <WrapperBox direction="column">
        <Content>
          <Title>{getLabel('exchange-announcements-announcements', i18n)}</Title>
          <Description>{getLabel('exchange-announcements-stayInformed', i18n)}</Description>
          {firstData && (
            <List justify="space-between" key={firstData.id}>
              <ListLeft>
                <a id="announcements-a-announcementsImg" href={firstData.url} target="_blank" rel="noopener noreferrer">
                  <img src={firstData.image} alt={firstData.title} />
                </a>
              </ListLeft>
              <ListRight>
                {/* <span>{firstData.type}</span> */}
                <span>{getLabel('exchange-announcements-newListings', i18n)}</span>
                <h2>
                  <a id="announcements-a-NewListingsTitle" href={firstData.url} target="_blank" rel="noopener noreferrer">
                    <LinesEllipsis
                      text={firstData.title}
                      maxLine="2"
                      ellipsis="..."
                      trimRight={true}
                      basedOn="letters"
                    />
                  </a>
                </h2>
                <p>
                  {getLabel('exchange-announcements-byBinanceTeam', i18n)}, {formatDate(firstData.time, 'm', 'cn')}
                </p>
                <LinesEllipsis
                  text={firstData.detail}
                  maxLine="2"
                  ellipsis="..."
                  trimRight={true}
                  basedOn="letters"
                />
                <FourData>
                  <ul>
                    {fourData.map(item => (
                      <li key={item.id}>
                        <a id={`announcements-a-li${item.id}`} href={item.url} target="_blank" rel="noopener noreferrer">
                          <LinesEllipsis
                            text={item.title}
                            maxLine="1"
                            ellipsis="..."
                            trimRight={true}
                            basedOn="letters"
                          />
                        </a>
                        <span>{formatDate(item.time, 'm', 'cn')}</span>
                      </li>
                    ))}
                  </ul>
                </FourData>
                <a
                  id="announcements-a-viewAll"
                  href={viewAll.replace('%locale', locale)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {getLabel('exchange-SelfOtherPairsToggler-More', i18n)} {'>>'}
                </a>
              </ListRight>
            </List>
          )}
        </Content>
      </WrapperBox>
    );
  }
}
